export const FETCH_ALL_CONNECTIONS_REQUEST = 'FETCH_ALL_CONNECTIONS_REQUEST';
export const FETCH_ALL_CONNECTIONS_SUCCESS = 'FETCH_ALL_CONNECTIONS_SUCCESS';
export const FETCH_ALL_CONNECTIONS_FAILURE = 'FETCH_ALL_CONNECTIONS_FAILURE';

export const FETCH_ALL_CONNECTIONS_COUNT_REQUEST = 'FETCH_ALL_CONNECTIONS_COUNT_REQUEST';
export const FETCH_ALL_CONNECTIONS_COUNT_SUCCESS = 'FETCH_ALL_CONNECTIONS_COUNT_SUCCESS';
export const FETCH_ALL_CONNECTIONS_COUNT_FAILURE = 'FETCH_ALL_CONNECTIONS_COUNT_FAILURE';
